export default __webpack_public_path__ + "static/media/Circle_of_Influence_Concern_Arrow_In.24aba28b.png";